import { getCmsAccountBanner } from "../../../app/api/getCmsAccountBanner";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { ICmsAccountBanner } from "../../../Orchestrator/Types/Interface/ICmsAccountBanner";

class GetCmsAccountBannerAction extends BaseAction<ICmsAccountBanner | null, void> {
  override async run(): Promise<ICmsAccountBanner | null> {
    let result: ICmsAccountBanner | null = null;
    try {
      const response = await getCmsAccountBanner();

      if (response.status === "ok" && response.answer) {
        result = response?.answer?.data ?? null;
      } else {
        console.warn("Failed to fetch account banner.");
      }
    } catch (error: any) {
      console.error("Error fetching account banner:", error);
    } finally {
      updateRecoilState("cmsAccountBannerAtom", result);
      return result;
    }
  }
}

export const getCmsAccountBannerAction = new GetCmsAccountBannerAction();
